import { patterns } from './patterns/patterns';

const validationHelpers = {
  notUndefinedOrNull(value: unknown): boolean {
    return value !== undefined && value !== null;
  },

  notZeroNumber(value: number): boolean {
    return value > 0;
  },

  notEmptyString(value: string): boolean {
    if (value) {
      return value.trim() !== '';
    }

    return value !== '';
  },

  numberNotZero(value: number): boolean {
    return value > 0;
  },

  notEmptyArray(value: unknown[] = []): boolean {
    return value?.length !== 0;
  },

  phoneCorrectFormat(value: PhoneNumber) {
    const phoneRegexp = new RegExp(patterns.phone);

    return phoneRegexp.test(value);
  },

  emailCorrectFormat<T>(value: T) {
    const emailRegexp = new RegExp(patterns.email);

    return emailRegexp.test(value as string);
  },

  innCorrectFormat(value: INN) {
    // TODO add checksum check from indicrm
    return value.length === 10 || value.length === 12;
  },

  kppCorrectFormat(value: KPP) {
    const kppRegexp = new RegExp(patterns.kpp);

    return kppRegexp.test(value);
  },

  kppCorrectLength(value: KPP) {
    return value.length === 9;
  },

  bicCorrectLength(value: BIC) {
    return value.length === 9;
  },

  settlementAccountCorrectLength(value: SettlementAccountNumber) {
    return value.length === 20;
  },

  correspondentAccountCorrectLength(value: CorrespondentAccountNumber) {
    return value.length === 20;
  },

  passwordCorrectLength(value: Password) {
    return value.length >= 6;
  },

  fileHasAcceptedMimeType(fileType: FileMimeType, acceptedExt: FileMimeType[]) {
    return acceptedExt.find(value => value === fileType);
  },

  fileHasAcceptedExtension(file: File, acceptedExt: FileExtension[]) {
    const fileExt = file.name.split('.').pop();
    acceptedExt.find(ext => ext === fileExt);
  },

  verificationDocumentHasCorrectExt(fileName: FileName) {
    return patterns.verificationDocNameExt.test(fileName);
  },

  fileHasCorrectSize(size: FileSizeKb) {
    return size / 1024 < 10000;
  },

  sipUriCorrectFormat<T>(value: T) {
    const re = new RegExp(patterns.sipUri);
    return re.test(value as string);
  },

  amoCrmCorrectDomain(domain: AccountDomain) {
    const pattern = new RegExp(patterns.correctAmoCrmDomain);

    return pattern.test(domain);
  },

  bitrixCorrectDomain(domain: AccountDomain) {
    const pattern = new RegExp(patterns.correctBitrixCrmDomain);

    return pattern.test(domain);
  },
};

export { validationHelpers };
